import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["id"]

import { computed } from 'vue';
import IoInputWrapper from '@/components/form/InputWrapper.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Checkbox',
  props: /*#__PURE__*/_mergeModels({
    label: { default: undefined }
  }, {
    "modelValue": { type: Boolean },
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const modelValue = _useModel<boolean>(__props, "modelValue");



const value = computed<boolean>({
  get() {
    return !!modelValue.value;
  },
  set(val: unknown) {
    modelValue.value = !!val;
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IoInputWrapper, {
    label: _ctx.label,
    class: "io-checkbox__wrapper"
  }, {
    inLabel: _withCtx(({ inputId }) => [
      _withDirectives(_createElementVNode("input", {
        id: inputId,
        class: "base-input__checkbox",
        type: "checkbox",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event))
      }, null, 8, _hoisted_1), [
        [_vModelCheckbox, value.value]
      ])
    ]),
    _: 1
  }, 8, ["label"]))
}
}

})